import { call, put, select } from 'redux-saga/effects';
import API from "../../API";
import {
  loadPrimaryEmotionsBreakdownError,
  loadPrimaryEmotionsBreakdownSuccess
} from "./charts-action-creators";
import {loadPrimaryEmotionsToFullReport} from "../full-report-primary-or-sentiment/full-report-primary-or-sentiment-action-creators";
import {prepareFiltersToSend} from "../filters/functions";

export default function* loadPrimaryEmotionsBreakdownRequest() {
  const reportUrl = yield select(state => state.report.reportUrl);
  const filters = yield select(state => state.filters.filtersToSend);
  try {
    const result = yield call(API.loadPrimaryEmotionsBreakdown, { reportUrl, filters });
    console.log(filters, 'FILTER FROM LOAD PRIMARY EMOTIONS');
    console.log(result, 'RESULT FROM LOAD PRIMARY EMOTIONS BREAKDOWN REQUEST');
    if (result.data.results && result.data.results.length) {
      const normalized = normalize(result.data.results);
      yield put(loadPrimaryEmotionsBreakdownSuccess(normalized));
      yield put(loadPrimaryEmotionsToFullReport(normalized))
    } else {
      yield put(loadPrimaryEmotionsBreakdownError("No data"));
    }

  } catch(error) {
    console.log(error, 'ERROR FROM LOAD PRIMARY EMOTIONS BREAKDOWN REQUEST');
    yield put(loadPrimaryEmotionsBreakdownError("Something went wrong..."));
  }
}

const normalize = data => {
  const total = data.reduce((acc, current) => {
    acc += current.count;
    return acc;
  }, 0);
  return data.map(d => {
    d.percent = Number(d.count / total * 100).toFixed(1);
    return d;
  })
};


// WEBPACK FOOTER //
// ./src/modules/charts/load-primary-emotions-breakdown-saga.js